import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            为什么选择51影院
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            四大核心优势，打造极致观影体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featureItems.map((feature) => (
            <div
              key={feature.title}
              className="group rounded-2xl bg-background-50 p-6 md:p-7 border border-background-200 text-center hover:-translate-y-1 transition-all duration-300"
            >
              <span className="inline-flex w-14 h-14 md:w-16 md:h-16 items-center justify-center rounded-2xl bg-accent-100 text-accent-500 mb-4 md:mb-5 text-2xl md:text-3xl group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={feature.icon}></i>
              </span>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-800 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}